import send2 from "../../../assets/images/send2.svg";
import ChoseBigm from "./ChoseBigm";
import ChoseBluer from "./ChoseBluer";
import ChoseKeyavo from "./ChoseKeyavo";

export default function WhyChosePro() {
  return (
    <div className="w-full">
      <div className="container mx-auto p-3 flex flex-col gap-4">
        <div className="flex flex-col gap-3 w-full">
          <p className="text-[24px] text-[#033F6A] font-semibold">
            Tại sao chọn sản phẩm của
          </p>
          <div className="border border-[#27C6FF] w-[7.125rem] h-10 rounded-[40px] bg-[#27C6FF] flex items-center justify-center">
            <p className="text-[16px] font-semibold text-white">BlueSkyIT</p>
          </div>
        </div>
        <div className="flex flex-col gap-10">
          <div>
            <ChoseBigm />
          </div>
          <div>
            <ChoseBluer />
          </div>
          <div>
            <ChoseKeyavo />
          </div>
        </div>
      </div>
    </div>
  );
}
